exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner[data-v-20ad1e66] {\n  width: 375px;\n  min-height: 150px;\n  background: #eef0f5;\n  cursor: pointer;\n}\n[data-v-20ad1e66] .image-default {\n  text-align: center;\n  line-height: 140px;\n}\n", ""]);

// exports
